import { render, staticRenderFns } from "./VerDetalleTipoMedidaModal.vue?vue&type=template&id=13d7be54&"
import script from "./VerDetalleTipoMedidaModal.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleTipoMedidaModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('13d7be54', component.options)
    } else {
      api.reload('13d7be54', component.options)
    }
    module.hot.accept("./VerDetalleTipoMedidaModal.vue?vue&type=template&id=13d7be54&", function () {
      api.rerender('13d7be54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TipoMedida/VerDetalleTipoMedidaModal.vue"
export default component.exports